export const getSanityEnv = () => process.env.SANITY_INTERNAL_ENV || 'production'
